/* eslint-disable @typescript-eslint/no-explicit-any */
import {Text, View} from '@react-pdf/renderer';
import React from 'react';
import {DateToddmmyyyyFormat} from '../../../../data/factory';
import {styles} from './styles';

const getCurrentDate = () => DateToddmmyyyyFormat(new Date());

export const AttestationScolaire = (props: any) => {
  const {detailContrat} = props;
  
  return (
    <View>
      <View style={styles.section}>
        <Text style={styles.title}>ATTESTATION D'ASSURANCE SCOLAIRE</Text>
      </View>
      <View style={styles.sousSection}>
        <Text style={styles.subtitle1}>Compte Client N° ....../....</Text>

        <View style={{margin: 7}} />

        <Text>
          {
            "Nous soussignés, La Compagnie d'Assurances   A    R   O   « Assurances - Réassurances - "
          }
        </Text>
        <Text>
          {
            'Omnibranches », B.P. N° 42, Làlana Solombavambahoaka Frantsay 77 - Antsahavola - '
          }
        </Text>
        <Text>{'ANTANANARIVO, certifions que :'}</Text>
        <View style={{margin: 1}} />
        <Text style={{alignSelf: 'center'}}>
          {detailContrat.nomPrenomContractant}
        </Text>
        <View style={{margin: 2}} />
        <Text>
          a souscrit auprès de notre Compagnie la police d'Assurance ci - après
          :
        </Text>
        <View style={{margin: 5, textAlign: 'center'}}>
          <Text style={styles.text}>
            <Text style={styles.textBolded}>ASSURANCE SCOLAIRE Police N° </Text>
            {detailContrat.numeroPolice}
          </Text>
        </View>

        <Text style={styles.subtitle2}>GARANTIES ET LIMITES :</Text>
        <View style={{margin: 2}} />
        <Text style={styles.subtitle3}>
          RESPONSABILITE CIVILE ET EXPLOITATION :
        </Text>
        <Text>
          <Text style={styles.textBolded}>- Dommage corporel : </Text> 400 000
          000 Ariary
        </Text>
        <Text>
          <Text style={styles.textBolded}>- Dommage materiel : </Text> 100 000
          000 Ariary
        </Text>
        <Text>dont : </Text>
        <View style={{marginLeft: 10}}>
          <Text>&#9642; Incendie, explosion : 15 000 000 Ariary </Text>
          <Text>&#9642; Dégâts Des Eaux : 15 000 000 Ariary</Text>
          <Text>
            &#9642; Dommages causés par un élève ou lycéen, ... stagiaire au
            matériel confié par 15 000 000 Ariary
          </Text>
          <Text style={{marginLeft: 5}}>
            l'entreprise d'accueil : 10 000 000 Ariary
          </Text>
        </View>
        <View style={{margin: 2}} />
        <Text>
          <Text style={styles.textBolded}>
            - Dommage immatériels consécutifs :{' '}
          </Text>{' '}
          25 000 000 Ariary
        </Text>
        <View style={{margin: 2}} />
        <Text>
          <Text style={styles.textBolded}>- Intoxications Alimentaires : </Text>{' '}
          50 000 000 Ariary par année d'assurrance avec un maximum
        </Text>
        <View style={{margin: 2}} />
        <Text style={{marginLeft: 5}}>
          de 10 000 000 Ariary par sinistre et/ou par événement
        </Text>
        <Text>
          <Text style={styles.textBolded}>- Défense et recours : </Text> 2 500
          000 Ariary
        </Text>
        <View style={{margin: 2}} />
        <Text>
          <Text style={styles.textBolded}>
            - Franchise sur Dommages matériels et immatériels consécutifs :{' '}
          </Text>
          10 % avec un minimum
        </Text>
        <Text style={{marginLeft: 5}}>{'    de 50 000 Ariary'}</Text>

        <View style={{margin: 5}} />
        <Text style={styles.subtitle3}>INDEMNITES CONTRACTUELLES :</Text>
        <Text>
          <Text style={styles.textBolded}>- Capital Décès : </Text> 2 500 000
          Ariary (+12 ans seulement)
        </Text>
        <Text>
          <Text style={styles.textBolded}>
            - Capital Infirmité Permanente :{' '}
          </Text>{' '}
          2 500 000 Ariary (Pour tout assuré)
        </Text>
        <Text>
          <Text style={styles.textBolded}>- Frais de traitement : </Text> 1 250
          000 Ariary
        </Text>
        <Text>dont : </Text>
        <View style={{marginLeft: 10}}>
          <Text>&#9642; prothèse dentaire : 100 000 Ariary par dent</Text>
          <Text>&#9642; prothèse auditive : 250 000 Ariary par appareil</Text>
          <Text>&#9642; lunettes : 250 000 Ariary</Text>
          <Text>
            &#9642; frais de transport : 25 000 Ariary par jour avec un maximum
            de 625 000 Ariary
          </Text>
          <Text>
            &#9642; frais de recherche et de secours : 1 250 000 Ariary
          </Text>
        </View>
        <Text>
          <Text style={styles.textBolded}>- Franchise : </Text> Néant
        </Text>
        <View style={{margin: 5}} />
        <Text>
          <Text style={styles.textBolded}> Au profit de l'enfant : </Text>{' '}
          {detailContrat.nomPrenomEleveAssure}{' '}
          <Text style={styles.textBolded}> OPTION : </Text>....
        </Text>
        <Text>
          <Text style={styles.textBolded}> Pour la période : </Text>{' '}
          {detailContrat.dateSouscription}{' '}
          <Text style={styles.textBolded}> au : </Text>{' '}
          {detailContrat.dateEcheance}{' '}
          <Text style={styles.textBolded}> à 00h. </Text>
        </Text>

        <Text style={{marginTop: 10}}>
          La présente attestation lui est délivrée pour servir et valoir ce que
          de droit.{' '}
        </Text>
        <Text
          style={{...styles.textBolded, marginTop: 20, alignSelf: 'flex-end'}}>
          Antananarivo, le {getCurrentDate()}
        </Text>
        <View style={{margin: 5}} />
        <Text
          style={{...styles.textBolded, alignSelf: 'flex-end', marginLeft: 7}}>
          POUR LA COMPAGNIE{' '}
        </Text>
      </View>
    </View>
  );
};
